import { api } from "../Api";
import i18n from "../../Config/i18n.js";

/**
 * Classe que faz as requisições dos usuários
 */
export class MaintenanceRequest {
    // operators, equipments, cities, procedures
    async getAllMaintenance(page: number, search: string, operators: Array<string>, equipments: Array<string>, cities: Array<string>, procedures:Array<string>,
    types: Array<string>, initialDate: string, finalDate: string):Promise<any>{
        try {
            let data = {
                params: {
                    search: search || '',
                    operadores: operators || [],
                    equipamentos: equipments || [],
                    cidades: cities || [],
                    data_inicial: initialDate || [],
                    data_final: finalDate || [],
                    tipos: types || [],
                    procedimentos: procedures || [],
                    page: page || 1,
                },
            };
            const response = await api.get("/Formularios", data);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // busca uma manutenção pelo id
    async getMaintenanceById(id: string): Promise<any> {
        try {
            const maintenance = await api.get(`/Formularios/${id}`);
            return maintenance.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // buscar todos os tipos de manutenção
    async getEquipmentsFilter(): Promise<any> {
        try {
            const equipments = await api.get(`/Manutencoes/filtro/equipamentos`);
            return equipments.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
    
    // buscar todas cidades
    async getCitiesFilter(): Promise<any> {
        try {
            const equipments = await api.get(`/Manutencoes/filtro/cidades`);
            return equipments.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
    
    // buscar todos os operadores
    async getOperatorsFilter(): Promise<any> {
        try {
            const equipments = await api.get(`/Manutencoes/filtro/operadores`);
            return equipments.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
    
    // buscar todos os procedimentos de manutenção
    async getProceduresFilter(): Promise<any> {
        try {
            const equipments = await api.get(`/Manutencoes/filtro/procedimentos`);
            return equipments.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async GetMaintenanceReports(data?: string): Promise<any>{
        try {
          const reports = await api.get(`/Formularios/relatorio/${data}`);
          return reports.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
}